import React from 'react';
import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';

import Dashboard from './Dashboard';
import { DashboardCategory } from './Dashboard/View/Category';
import DashboardEntity from './Dashboard/View/Entity';
import DashboardVenture from './Dashboard/View/Venture';

const routes: IAppRoute[] = [
  {
    path: '/',
    exact: true,
    roles: [
      userRoles.sysAdmin,
      userRoles.admin,
      userRoles.auditor,
      userRoles.holding,
      userRoles.venturer,
      userRoles.operator,
    ],
    isProfileSelectedDependent: true,
    component: Dashboard,
  },
  {
    path: '/venture/:ventureId',
    roles: [
      userRoles.sysAdmin,
      userRoles.admin,
      userRoles.auditor,
      userRoles.holding,
      userRoles.venturer,
      userRoles.operator,
    ],
    isProfileSelectedDependent: true,
    exact: true,
    component: DashboardVenture,
  },
  {
    path: '/venture/:ventureId/category/:categoryId',
    roles: [
      userRoles.sysAdmin,
      userRoles.admin,
      userRoles.auditor,
      userRoles.holding,
      userRoles.venturer,
      userRoles.operator,
    ],
    isProfileSelectedDependent: true,
    exact: true,
    component: DashboardCategory,
  },
  {
    path: '/venture/:ventureId/category/:categoryId/entity/:entityId',
    roles: [
      userRoles.sysAdmin,
      userRoles.admin,
      userRoles.auditor,
      userRoles.holding,
      userRoles.venturer,
      userRoles.operator,
    ],
    isProfileSelectedDependent: true,
    component: DashboardEntity,
  },
];

const DashboardRouter: React.FC & { routes?: IAppRoute[] } = ({ children }) => {
  return <>{children}</>;
};

DashboardRouter.routes = routes;

export default DashboardRouter;
